export class TabData<T> {
  constructor(public data: T) {}
}
